import { connect } from "react-redux";
import { Dispatch } from "react";
import actions from "../redux/actions/Index";
import CategoryCityLevelPage from "../components/pages/categoryCityLevel/CategoryCityLevelPage";
import {
  ICategoryCityLevelPayload,
  ICategoryListingNormalizedData,
  ICategoryProductsResponse,
  ICategoryProductUpdatePayload,
  IGetQueryParams,
  IIdValuePairResponse,
} from "../interfaces/Index";

export const mapStateToProps = (state: any, props: any): ContainerProps => {
  const { category, zone } = state;
  return {
    isLoading: category.isLoading,
    isError: category.isError,
    error: category.error,
    pagination: category.pagination,
    isCategoryUpdated: category.isCategoryUpdated,
    cityList: zone.citiesList,
    categoryList: category.categories,
    categoryProductList: category.categoryProducts,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    fetchCities: () => dispatch(actions.fetchCities()),
    fetchCategories: (cityId: string, queryParam: IGetQueryParams) =>
      dispatch(actions.fetchCategoriesForCity(cityId, queryParam)),
    fetchCategoryProducts: (categoryId: string, cityId: string) =>
      dispatch(actions.fetchCategoryProductsForCity(categoryId, cityId)),
    reorderCategoryProducts: (
      categoryId: string,
      cityId: string,
      payload: ICategoryProductUpdatePayload
    ) =>
      dispatch(
        actions.reorderCategoryProductsForCity(categoryId, cityId, payload)
      ),
    updateCategory: (
      categoryId: string,
      cityId: string,
      payload: ICategoryCityLevelPayload
    ) => dispatch(actions.updateCityLevelCategory(categoryId, cityId, payload)),
  };
};

const CategoryCityLevelContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CategoryCityLevelPage);
export default CategoryCityLevelContainer;

export interface ContainerProps {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  pagination: any;
  isCategoryUpdated: boolean;
  cityList: IIdValuePairResponse[];
  categoryList: ICategoryListingNormalizedData[][];
  categoryProductList: Array<ICategoryProductsResponse>;
}
